import { useWoody } from '../../woody/woody.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { smartCollectionQueryKeys } from '../queries/smartCollection.queryKeys.js';
import { useRouter } from '@fabric-app/compat';
import { generatePath } from '@fabric-app/utils/url/routing';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { isWoodyError } from '../../errors/errors.utils.js';
import { toast } from '../../store/alerts.js';
import { appRoutes } from '../../app/routing/routes.config.js';
import { defaultResourceListPreferences } from '../../resources/components/ResourceList/contexts/defaultPreferences.js';

const useMutationSmartCollectionCreate = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const { track } = useAnalytics();
  const router = useRouter();
  const mutation = useMutation({
    mutationFn: ({ data }) => {
      return client.v2("/v2/smart-collections", {
        method: "post",
        body: data
      });
    },
    onError: (error) => {
      if (isWoodyError(error)) {
        if (error.detail === "err_auto_suggestion_failed") {
          toast({
            content: "Couldn't create smart collection. Please try a different prompt."
          });
          return;
        }
      }
      toast({
        content: "Couldn't create smart collection. Please try a again."
      });
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(smartCollectionQueryKeys.list(), (prevData) => {
        return [
          ...prevData || [],
          data
        ];
      });
      queryClient.setQueryData(smartCollectionQueryKeys.item(data.id), {
        ...data,
        preferences: defaultResourceListPreferences
      });
      track(AnalyticsEvents.SmartCollectionCreated, {
        ...variables
      });
      queryClient.invalidateQueries({
        queryKey: smartCollectionQueryKeys.list()
      });
      if (variables.redirectOnSuccess) {
        setTimeout(() => {
          router.push(generatePath(appRoutes.smartCollections.detail, {
            smartCollectionId: data.id
          }));
        }, variables.redirectDelay || 0);
      }
    }
  });
  return mutation;
};

export { useMutationSmartCollectionCreate };
//# sourceMappingURL=useMutationSmartCollectionCreate.js.map
